(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.RejectAcquisitionPackage = factory(root.Swagger.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The RejectAcquisitionPackage model module.
   * @module model/RejectAcquisitionPackage
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RejectAcquisitionPackage</code>.
   * @alias module:model/RejectAcquisitionPackage
   * @class
   */
  var exports = function() {












  };

  /**
   * Constructs a <code>RejectAcquisitionPackage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RejectAcquisitionPackage} obj Optional instance to populate.
   * @return {module:model/RejectAcquisitionPackage} The populated <code>RejectAcquisitionPackage</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('action')) {
        obj['action'] = ApiClient.convertToType(data['action'], 'String');
      }
      if (data.hasOwnProperty('unknown_person')) {
        obj['unknown_person'] = ApiClient.convertToType(data['unknown_person'], 'Boolean');
      }
      if (data.hasOwnProperty('not_intended_for_me')) {
        obj['not_intended_for_me'] = ApiClient.convertToType(data['not_intended_for_me'], 'Boolean');
      }
      if (data.hasOwnProperty('do_not_want_it')) {
        obj['do_not_want_it'] = ApiClient.convertToType(data['do_not_want_it'], 'Boolean');
      }
      if (data.hasOwnProperty('derogatory_language')) {
        obj['derogatory_language'] = ApiClient.convertToType(data['derogatory_language'], 'Boolean');
      }
      if (data.hasOwnProperty('sexual_explicit')) {
        obj['sexual_explicit'] = ApiClient.convertToType(data['sexual_explicit'], 'Boolean');
      }
      if (data.hasOwnProperty('harassment')) {
        obj['harassment'] = ApiClient.convertToType(data['harassment'], 'Boolean');
      }
      if (data.hasOwnProperty('hateful_content')) {
        obj['hateful_content'] = ApiClient.convertToType(data['hateful_content'], 'Boolean');
      }
      if (data.hasOwnProperty('child_abuse')) {
        obj['child_abuse'] = ApiClient.convertToType(data['child_abuse'], 'Boolean');
      }
      if (data.hasOwnProperty('unwanted_commercial_or_spam')) {
        obj['unwanted_commercial_or_spam'] = ApiClient.convertToType(data['unwanted_commercial_or_spam'], 'Boolean');
      }
      if (data.hasOwnProperty('other')) {
        obj['other'] = ApiClient.convertToType(data['other'], 'String');
      }
    }
    return obj;
  }


  /**
   * Type of acquisition user is going to reject.Example : share, get,buy,transfer,extend and clone.
   * @member {String} action
   */
  exports.prototype['action'] = undefined;

  /**
   * When reason to reject is 'I do not know the person who shared this with me'.
   * @member {Boolean} unknown_person
   */
  exports.prototype['unknown_person'] = undefined;

  /**
   * when the reason to reject is 'It was not intended for me'.
   * @member {Boolean} not_intended_for_me
   */
  exports.prototype['not_intended_for_me'] = undefined;

  /**
   * when the reason to reject is 'I do not want it; it is clogging up my list'.
   * @member {Boolean} do_not_want_it
   */
  exports.prototype['do_not_want_it'] = undefined;

  /**
   * when the reason to reject is 'Derogatory Language'.
   * @member {Boolean} derogatory_language
   */
  exports.prototype['derogatory_language'] = undefined;

  /**
   * when the reason to reject is 'Sexual explicit or pornographic content'.
   * @member {Boolean} sexual_explicit
   */
  exports.prototype['sexual_explicit'] = undefined;

  /**
   * when the reason to reject is 'Harassment or bullying'.
   * @member {Boolean} harassment
   */
  exports.prototype['harassment'] = undefined;

  /**
   * when the reason to reject is 'Hateful or violent content'.
   * @member {Boolean} hateful_content
   */
  exports.prototype['hateful_content'] = undefined;

  /**
   * when the reason to reject is 'Child Abuse'.
   * @member {Boolean} child_abuse
   */
  exports.prototype['child_abuse'] = undefined;

  /**
   * when the reason to reject is 'Unwanted Commercial content or spam'.
   * @member {Boolean} unwanted_commercial_or_spam
   */
  exports.prototype['unwanted_commercial_or_spam'] = undefined;

  /**
   * When user is rejecting package with his/her own reason he/she will mention that message in other field.
   * @member {String} other
   */
  exports.prototype['other'] = undefined;




  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/model/RejectAcquisitionPackage.js
 ** module id = 249
 ** module chunks = 0
 **/